import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateDeskExternalPayrollSystemSettingsRequest extends BaseUpdateRequest {
    externalPayrollSystemId = '';
}
